import { render } from "./RestaurantsInline.vue?vue&type=template&id=3dc8b19f"
import script from "./RestaurantsInline.vue?vue&type=script&lang=js"
export * from "./RestaurantsInline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__